export const BASEURL = import.meta.env.VITE_BASE_URL as string;

export const FrontendURL = import.meta.env.VITE_APP_URL as string;

export const LIVEKIT_SERVER_URL = import.meta.env
  .VITE_LIVEKIT_SERVER_URL as string;

export const R2_ENDPOINT = import.meta.env.VITE_R2_ENDPOINT as string;

/** Backend base URL (GraphQL endpoint with the `/graphql` suffix stripped). */
export function getApiBaseUrl(): string {
  return String(BASEURL || "http://localhost:3000/graphql").replace(
    /\/graphql\/?$/,
    "",
  );
}

/** Map original/<file> → optimized/<file>; leave other keys unchanged. */
export function toOptimizedKey(path: string): string {
  return path.replace(/(^|\/)original\//, "$1optimized/");
}

function resolveCdnUrl(path: string): string {
  const trimmed = path.trim();
  if (!trimmed) return "";
  if (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("blob:") ||
    trimmed.startsWith("data:") ||
    trimmed.startsWith("/")
  ) {
    return trimmed;
  }
  return `${R2_ENDPOINT}/${trimmed.replace(/^\/+/, "")}`;
}

/**
 * Preview URL (optimized when available).
 * Prefer explicit optimized key; otherwise derive from original/ convention.
 */
export function getMediaUrl(
  path?: string | null,
  optimizedPath?: string | null,
): string {
  if (optimizedPath?.trim()) {
    return resolveCdnUrl(optimizedPath);
  }
  if (!path) return "";
  return resolveCdnUrl(toOptimizedKey(path));
}

/** Full / original image URL (no optimization swap). */
export function getOriginalMediaUrl(path?: string | null): string {
  if (!path) return "";
  return resolveCdnUrl(path);
}
